<template>
  <AppContainer v-if="navigation" class="btns-container ms-0 ps-0 mb-4" start>
    <div class="flex justify-end gap-3">
      <AppBtn
        v-for="dir in ['back', 'next']"
        class="btn"
        :icon="`mdi:chevron-${getDirection(dir == 'back' ? 'back' : 'next')}`"
        variant="outlined"
        :size="mobile ? 'x-small' : 'small'"
        still primary
        @click="carousel?.[dir == 'back' ? 'prev' : 'next']()"
      />
    </div>
  </AppContainer>
  <Carousel
    v-bind="$attrs" 
    ref="carousel"
    :dir="rtl ? 'rtl' : 'ltr'"
    :class="{ end, elevated }"
    data-allow-mismatch
  >
    <slot />
    <template v-if="pagination" #addons>
      <Pagination />
    </template>
  </Carousel>
</template>

<script setup lang="ts">
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Pagination } from 'vue3-carousel';
import type { CarouselMethods } from 'vue3-carousel';

defineOptions({ inheritAttrs: false });

defineProps<{
  navigation?: boolean;
  pagination?: boolean;
  end?: boolean;
  elevated?: boolean;
}>();

const carousel = useTemplateRef<CarouselMethods>('carousel');
const { getDirection } = useFormat();
const { rtl } = useLocalization();
const { mobile } = useBreakpoints();

defineExpose({
  slideTo: (i: number) => carousel.value?.slideTo(i),
  next: () => carousel.value?.next(),
  prev: () => carousel.value?.prev()
});
</script>

<style scoped lang="scss">
.btns-container .btn {
  color: #fff;
  font-size: 20px;
  border-radius: 8px;
}
.elevated {
  margin-inline-start: calc(-1 * var(--space-5));

  :deep(.carousel__slide) {
    padding: var(--space-5);
  }
}

@media (min-width: 851px) {
  .end {
    :deep(.carousel__slide) {
      justify-content: flex-start;
    }
  }
}

@media (max-width: 850px) {
  .elevated {
    margin-inline-end: calc(-1 * var(--space-5));
  }
  .btns-container {
    margin-bottom: var(--space-2) !important;
  }
}
</style>